import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import Icon from 'components/Icon'
import theme from 'theme'

export const Heading = (props) => <Text as="h1" color="normal" {...props} />

export const Collapsing = ({ collapsed, ...rest }) => (
  <div
    css={{
      maxHeight: collapsed ? 0 : 640,
      overflow: 'hidden',
      transition: '350ms max-height'
    }}
    {...rest}
  />
)

Collapsing.propTypes = {
  collapsed: PropTypes.bool
}

export const Message = ({ title, children, ...props }) => (
  <div css={{ padding: theme.space[5] }} {...props}>
    <Text as="h3" color="normal">
      {title}
    </Text>
    {children && (
      <Text as="h4" color="light">
        {children}
      </Text>
    )}
  </div>
)

Message.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node
}

export const FilterInputSegment = (props) => (
  <div
    css={{ padding: theme.space[4], borderBottom: theme.border.base }}
    {...props}
  />
)

export const Field = (props) => (
  <div
    css={{
      display: 'flex',
      marginBottom: theme.space[4],

      '&:last-child': {
        marginBottom: 0
      }
    }}
    {...props}
  />
)

export const Name = (props) => (
  <div
    css={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      paddingRight: theme.space[7],
      justifyContent: 'flex-start'
    }}
    {...props}
  />
)

export const Label = (props) => <Text as="h4" color="medium" {...props} />

export const Description = (props) => <Text as="small" {...props} />

export const Pill = ({ inclusive, ...rest }) => (
  <span
    css={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      cursor: 'pointer',
      margin: theme.space[1],
      border: `1px solid ${inclusive ? 'transparent' : theme.colors.steel[1]}`,
      borderRadius: 1000,
      padding: '2px 12px',
      fontSize: theme.fontSizes[0],
      fontWeight: theme.fontWeights[0],
      color: inclusive ? 'white' : theme.colors.steel[1],
      backgroundColor: inclusive ? theme.colors.blue[0] : 'transparent'
    }}
    {...rest}
  />
)

Pill.propTypes = {
  inclusive: PropTypes.bool
}

export const Times = ({ inclusive, ...rest }) => (
  <div
    css={{
      borderRadius: theme.borderRadius[2],
      marginLeft: theme.space[1],
      backgroundColor: inclusive ? theme.colors.white[0] : theme.colors.gray[0],
      color: inclusive ? theme.colors.blue[0] : 'white',
      display: 'grid',
      placeItems: 'center'
    }}
    {...rest}
  >
    <Icon
      css={{ width: theme.space[3], height: theme.space[3] }}
      icon="close"
    />
  </div>
)

Times.propTypes = {
  inclusive: PropTypes.bool
}
